"use strict";
/**
 *
 * Form
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
class FormConfigRef {
    constructor(config, submitHandler) {
        this.submitHandler = submitHandler;
        this.config = config;
        if (this.config.el) {
            this.config.el.addEventListener('submit', this.submitHandler);
        }
    }
    get current() {
        return this.config;
    }
    set current(config) {
        if (this.config.el !== config.el) {
            // if the form element was already assigned, remove the event listener before re-assigning another element
            if (this.config.el) {
                this.config.el.removeEventListener('submit', this.submitHandler);
            }
            if (config.el) {
                config.el.addEventListener('submit', this.submitHandler);
            }
        }
        this.config = config;
    }
}
exports.FormConfigRef = FormConfigRef;
